import { useConditionFieldTypeFieldPath } from '../fieldPaths';
import { useQueryErrorStateContext } from '../../../contexts/queryErrorState';

export const useHasConditionFieldTypeError = () => {
  const fieldPath = useConditionFieldTypeFieldPath();
  const { getHasErrorFromFieldPath } = useQueryErrorStateContext();
  const errorFromFieldPath = getHasErrorFromFieldPath(fieldPath);

  return errorFromFieldPath;
};
